import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "@/lib/api";
import { HeartPulse } from "lucide-react";

// Dispatch Board header counter: "2 EDs on divert" — click → Resource & Hospital Status.
export const DivertBadge = () => {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    const load = () => client.get("/hospitals/divert-summary").then((r) => setD(r.data)).catch(() => {});
    load(); const t = setInterval(load, 120000); return () => clearInterval(t);
  }, []);
  if (!d?.ok) return null;
  const hot = d.count > 0;
  const tip = [...d.divert.map((h) => `⛔ ${h.name} (${h.state}) — ${h.reason}`), ...d.advisory.slice(0, 6).map((h) => `⚠ ${h.name} (${h.state}) — ${h.reason}`)].join("\n") || "All MD/PA EDs reporting normal";
  return (
    <button data-testid="divert-badge" onClick={() => nav("/resources")} title={tip}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 border text-xs font-head transition-colors ${hot ? "bg-[#DC2626]/15 border-[#DC2626]/60 text-[#FCA5A5] animate-pulse" : d.advisory_count ? "bg-[#F59E0B]/10 border-[#F59E0B]/50 text-[#FCD34D]" : "bg-[#22C55E]/10 border-[#22C55E]/40 text-[#86EFAC]"}`}>
      <HeartPulse size={13} />
      {hot ? `${d.count} ED${d.count > 1 ? "s" : ""} ON DIVERT` : d.advisory_count ? `${d.advisory_count} ED ADVISOR${d.advisory_count > 1 ? "IES" : "Y"}` : "EDs NORMAL"}
      {hot && d.advisory_count > 0 && <span className="text-[#FCD34D]">· {d.advisory_count} adv</span>}
    </button>
  );
};
